import React, {Fragment} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from "react-i18next";
import EnhancedModal from "../../../components/enhanced-modal";
import {Button} from "antd";
import {
    ARTEFACT_TYPE_DATAFLOW_PUBLISHING,
    getArtefactDownloadOptions
} from "../../../constants/download";
import {MODAL_WIDTH_SM} from "../../../styles/constants";
import ArtefactDownloadForm from "../../../components/artefact-download-form";
import {
    changeDataflowPublishingListDataflowDownload,
    downloadDataflowPublishingListDataflow,
    hideDataflowPublishingListDataflowDownload,
    readDataflowPublishingListDataflowDownloadCubeAndDdBDataflow,
    readDataflowPublishingListDataflowDsdDataflow,
    showDataflowPublishingListDataflowDownloadQuery, toggleDataflowPublishingQueryPreview
} from "./actions";
import DataflowDownloadQueryForm from "./DataflowDownloadQueryForm";
import Call from "../../../hocs/call";
import {clearMappingPreviewMappingSet, getMappingSetPreviewToken} from "../mapping-set/mapping-set-wizard/actions";
import ModalPreview from "../mapping-set/mapping-set-wizard/components/ModalPreview";
import {getSimplifiedFilterObj} from "./utils";

const mapStateToProps = state => ({
    dataLanguages: state.config.dataManagement.dataLanguages,
    dlDataflowParams: state.scenes.mappingHandler.dataflowPublishing.dlDataflowParams,
    dlDataflowTriplet: state.scenes.mappingHandler.dataflowPublishing.dlDataflowTriplet,
    dlRows: state.scenes.mappingHandler.dataflowPublishing.dlRows,
    dlCols: state.scenes.mappingHandler.dataflowPublishing.dlCols,
    dlDsdCols: state.scenes.mappingHandler.dataflowPublishing.dlDsdCols,
    dlDsdTriplet: state.scenes.mappingHandler.dataflowPublishing.dlDsdTriplet,
    dlDsdDimensions: state.scenes.mappingHandler.dataflowPublishing.dlDsdDimensions,
    showDataflowPreview: state.scenes.mappingHandler.dataflowPublishing.showDataflowPreview,
    dataflowPreviewToken: state.scenes.mappingHandler.mappingSet.wizard.mappingSetPreviewToken,
});

const mapDispatchToProps = dispatch => ({
    onDownloadHide: () => dispatch(hideDataflowPublishingListDataflowDownload()),
    onDownloadChange: fields => dispatch(changeDataflowPublishingListDataflowDownload(fields)),
    onDownload: (dataflowTriplet, dataflowDownloadParams, dlCols) =>
        dispatch(downloadDataflowPublishingListDataflow(dataflowTriplet, dataflowDownloadParams, dlCols)),
    openQueryForm: () =>
        dispatch(readDataflowPublishingListDataflowDownloadCubeAndDdBDataflow()),
    onDownloadQueryShow: () => dispatch(showDataflowPublishingListDataflowDownloadQuery()),
    fetchDownloadDsd: triplet => dispatch(readDataflowPublishingListDataflowDsdDataflow(triplet)),
    togglePreview: (value) => dispatch(toggleDataflowPublishingQueryPreview(value)),
    onGetDataflowPreviewToken: (dataflowTriplet, token, filter) => dispatch(getMappingSetPreviewToken(dataflowTriplet.id, dataflowTriplet.agencyID, dataflowTriplet.version, token, 1, filter)),
    clearPreview: (dataflowPreviewToken) => dispatch(clearMappingPreviewMappingSet(dataflowPreviewToken)),
});

const DataflowDownload = ({
                              t,
                              dataLanguages,
                              dlDataflowParams,
                              dlDsdTriplet,
                              dlDsdDimensions,
                              dlDataflowTriplet,
                              dlCols,
                              onDownloadHide,
                              onDownloadChange,
                              openQueryForm,
                              onDownloadQueryShow,
                              onDownload,
                              onGetDataflowPreviewToken,
                              dataflowPreviewToken,
                              fetchDownloadDsd,
                              dlDsdCols,
                              togglePreview,
                              showDataflowPreview,
                              clearPreview,
                          }) => {
    return (
        <Fragment>
            <EnhancedModal
                visible={!!dlDataflowTriplet}
                onCancel={onDownloadHide}
                footer={
                    <div>
                        <Button onClick={onDownloadHide}>
                            {t('commons.buttons.close.title')}
                        </Button>
                        <Button
                            onClick={() => {
                                onDownload(dlDataflowTriplet, dlDataflowParams, dlCols)
                            }}
                            type="primary"
                            disabled={
                                !dlDataflowParams || (dlDataflowParams && !dlDataflowParams.format)
                            }
                        >
                            {t('commons.buttons.download.title')}
                        </Button>
                    </div>
                }
                width={MODAL_WIDTH_SM}
                title={t('scenes.dataManager.dataflowBuilder.dataflowDownload.modals.download.title', {
                    id: dlDataflowTriplet ? dlDataflowTriplet.id : ""
                })}
            >
                <Call
                    cb={fetchDownloadDsd}
                    cbParam={dlDsdTriplet}
                    disabled={!dlDsdTriplet || !!dlDsdDimensions}
                >
                    <ArtefactDownloadForm
                        downloadArtefactForm={dlDataflowParams}
                        onChange={onDownloadChange}
                        options={getArtefactDownloadOptions(t, ARTEFACT_TYPE_DATAFLOW_PUBLISHING)}
                        langs={dataLanguages}
                        queryFormRead={openQueryForm}
                        queryFormShow={onDownloadQueryShow}
                        queryPreviewShow={() => {
                            onGetDataflowPreviewToken(dlDataflowTriplet, dataflowPreviewToken, dlDataflowParams ? getSimplifiedFilterObj(dlDataflowParams.filter).Filter : null);
                            togglePreview(true);
                        }}
                        isQuerySet={dlDataflowParams && dlDataflowParams.selCols !== null}
                        isQueryPreviewShowDisabled={dlDataflowParams && dlDataflowParams.selCols === null}
                        dimensions={dlDsdCols}
                        sdmxFilters
                    />
                </Call>
            </EnhancedModal>
            <DataflowDownloadQueryForm/>
            <ModalPreview isRowsModalVisible={showDataflowPreview}
                          onRowsModalHide={() => {
                              togglePreview(false);
                              clearPreview(dataflowPreviewToken);
                          }}
                          dataflowTriplet={dlDataflowTriplet}
                          token={dataflowPreviewToken}
                          dataflowParams={dlDataflowParams}
            />
        </Fragment>
    )
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    translate(),
)(DataflowDownload);
